import { render, staticRenderFns } from "./EditBanner.vue?vue&type=template&id=d89cc8ea&scoped=true"
import script from "./EditBanner.vue?vue&type=script&lang=js"
export * from "./EditBanner.vue?vue&type=script&lang=js"
import style0 from "./EditBanner.vue?vue&type=style&index=0&id=d89cc8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89cc8ea",
  null
  
)

export default component.exports